// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"527":"9b5d4fa7","910":"01f28292"}[chunkId] + ".chunk.js";
};